export default "__VITE_ASSET__edef6226__"